import React from 'react';

import { LocationLoader } from '@/core/components/inputs/CityInput/components/LocationLoader';
import LocateMeButton from '@/core/components/inputs/CityInput/LocateMeButton';
import ScrollDownItem from '@/core/components/ScrollDownItem';
import { LocDomain } from '@/core/lib/new-architecture/domain/locs.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const CityOptions: React.FC<{
  items: LocDomain[] | null;
  userItem: LocDomain | null;
  isLoading: boolean;
  isSearching: boolean;
  onSelect: (selected: LocDomain) => (event?: React.MouseEvent<HTMLButtonElement>) => void;
  locateMeId: string;
}> = ({ items, isLoading, isSearching, userItem, onSelect, locateMeId }) => {
  const { t } = useTranslationContext(['common']);

  return isLoading ? (
    <LocationLoader />
  ) : (
    <>
      {items?.length === 0 && <p className="text-body-secondary p-3 text-content-primary">{t('inputs.city.modal.no-search-results', { ns: 'common' })}</p>}

      {isSearching ? (
        items?.map(item => <ScrollDownItem key={item.getLoc()} type="button" icon="pin" content={item.getLabel() ?? ''} onClick={onSelect(item)} />)
      ) : (
        <>
          {userItem && (
            <>
              <p className="text-caption-primary px-2 font-normal text-content-primary">{t('inputs.city.modal.user-item', { ns: 'common' })}</p>
              <ScrollDownItem key={userItem.getLoc()} type="button" icon="pin" content={userItem.getLabel() ?? ''} onClick={onSelect(userItem)} />
            </>
          )}
          <LocateMeButton id={locateMeId} onSelect={loc => onSelect(loc)()} />
        </>
      )}
    </>
  );
};
